<template>
    <div class="text-center">
        <v-dialog
            v-model="show"
            width="unset"
            max-width="500"
            tabindex="-1"
            role="dialog"
            transition="v-expand-y-transition"
            persistent
        >
            <v-card
                class="elevation-12"
                max-width="330px"
                transition="v-expand-y-transition"
            >
                <v-container class="pa-7 text-center">
                    <div class="d-flex justify-center mb-6">
                        <v-img
                            src="/svg/undraw_happy_announcement_re_tsm.svg"
                            max-width="170"
                        />
                    </div>
                    <h1>{{ $_userCanPostOffers ? 'Congratulations' : 'Yay!! Good To Go' }}</h1>
                    <p class="grey--text">
                        Onboarding completed click below to perform a transaction
                    </p>
                </v-container>

                <v-card-actions
                    v-if="$_userCanPostOffers"
                    class="px-7"
                >
                    <v-btn
                        :to="{ name: 'offers-create' }"
                        color="primary"
                        class="text-none white--text rounded-lg mb-3"
                        depressed
                        small
                        dark
                    >
                        Create Transfer
                    </v-btn>
                    <v-spacer />
                    <v-btn
                        :to="{ name: 'offers-list' }"
                        color="primary"
                        class="text-none white--text rounded-lg mb-3"
                        depressed
                        small
                        dark
                    >
                        Request Payment
                    </v-btn>
                </v-card-actions>

                <v-card-actions
                    v-else
                    class="px-7"
                >
                    <v-btn
                        :to="{ name: 'offers-list' }"
                        color="primary"
                        class="text-none white--text rounded-lg mb-3"
                        depressed
                        block
                        small
                        dark
                    >
                        Proceed To Make Money Transfer
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { mapMutations } from 'vuex';

    export default {
        props: {
            value: {
                type: Boolean,
                required: true,
            },
        },
        computed: {
            show: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                },
            },
        },
        watch: {
            show: {
                handler(v) {
                    if (v && this.$_userCanPostOffers) this.setOnboarding(false);
                },
            },
        },
        methods: {
            ...mapMutations([
                'setOnboarding',
            ]),
        },
    };
</script>
